import { JSMOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";
import { SignupBackgroundLayout } from "@/components/signup/layouts/signup-background-layout";
import { ReturnToProduct } from "@/components/signup/site-activation/components/common/return-to-product";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils/logos/service-collection-logo";
import { ExperimentView } from "@/utils/experiment/experiment-view";
import { experiments } from "@/utils/experiment/manifest";

import { Headings } from "../components/headings";
import { PickUpWhereYouLeftOffText } from "../components/sub-heading";
import { WelcomeBackText } from "../components/welcome-back-heading";

const CurrentProductUserContent = () => {
    return (
        <>
            <Headings
                main={<WelcomeBackText />}
                sub={<PickUpWhereYouLeftOffText />}
            />
            {/* everyone with a service collection should see a return to product experience */}
            <SiteActivation CurrentProductUser={<ReturnToProduct />} />
        </>
    );
};

export const CurrentProductUser = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <CurrentProductUserContent />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <CurrentProductUserContent />
                </SignupBackgroundLayout>
            )
        }
    />
);
